module.exports = __webpack_public_path__ + "img/30CreekRoad_Small.7bbc4575.png";